import "./pagination.scss";

import React from "react";
import Desktop from "./Desktop";
import Mobile from "./Mobile";

const Pagination = ({ current_page = 1, num_pages = 1, uri }) => {
  return (
    <>
      <Desktop current_page={current_page} num_pages={num_pages} uri={uri} />
      <Mobile current_page={current_page} num_pages={num_pages} uri={uri} />
    </>
  );
};

export default Pagination;
